<template>
  <header class="header-global bg-primary">
    <b-navbar toggleable="md" fixed="top" sticky type="dark">
      <b-navbar-brand href="/"
        ><img src="../../public/logo/white.png" alt="logo"
      /></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse v-if="IsLoggedIn" id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/country">Shop</b-nav-item>
          <b-nav-item href="/bulkupload">Bulk Upload</b-nav-item>
          <b-nav-item v-if="!ShowIfMalawi" href="/flexipaybalance"
            >Received Payments</b-nav-item
          >
          <b-nav-item-dropdown text="Reports">
            <b-dropdown-item href="/inbox">Inbox</b-dropdown-item>
            <b-dropdown-item href="/walletTransactions"
              >Credits</b-dropdown-item
            >
            <b-dropdown-item href="/customertransactions"
              >Customer Transactions</b-dropdown-item
            >
            <b-dropdown-item href="/customeroveraltransactions"
              >Customer Overal Transactions</b-dropdown-item
            >
            <b-dropdown-item href="/productoveralsales"
              >Product Sales</b-dropdown-item
            >
            <b-dropdown-item href="/bulkuploadreport"
              >Bulk Upload Report</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown text="Options" right>
            <b-dropdown-item v-if="!ShowIfMalawi" href="/replay"
              >Refresh Zesa</b-dropdown-item
            >
            <b-dropdown-item href="/referral"
              >Register a Referal</b-dropdown-item
            >
            <b-dropdown-item href="/team">Add a Team Member</b-dropdown-item>
            <b-dropdown-item v-if="!ShowIfMalawi" href="/bankingdetails"
              >Banking Details</b-dropdown-item
            >
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ GetLoggedInUser }}</em>
            </template>
            <b-dropdown-item href="/changepassword"
              >Change Password</b-dropdown-item
            >
            <b-dropdown-item @click="SignOut" href="#"
              >Sign Out</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
      <b-collapse v-else id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="/landing#developers">API for Developers</b-nav-item>
          <b-nav-item href="/landing#partners">Partners</b-nav-item>
          <b-nav-item href="/landing#about">About Us</b-nav-item>
          <b-nav-item href="/landing#contact">Contact</b-nav-item>
          <b-nav-item href="/login">Sign In</b-nav-item>
          <b-nav-item href="/register">Register</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import { userAuth } from "../services/security";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    Loading,
  },
  data: function () {
    return {
      register: "/register",
      isLoading: true,
      fullPage: true,
    };
  },
  computed: {
    IsLoggedIn: function () {
      return userAuth.data().user.isAuthenticated;
    },
    GetLoggedInUser: function () {
      return userAuth.GetUserName();
    },
    ...mapGetters("originatorStore", { originator: "getOriginator" }),
    ShowIfMalawi: function () {
      return this.originator == "mw";
    },
  },
  methods: {
    SignIn: async function () {
      await userAuth.signIn("/products");
    },
    SignOut: async function () {
      await userAuth.SignOut();
    },
  },
};
</script>
<style>
</style>
